import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  private currentStoreId: string | null = null;

  constructor(private router: Router) {
    // Subscribe to route changes to track the current store ID
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateCurrentStoreId();
      });

    // Initialize on first load
    this.updateCurrentStoreId();
  }

  private updateCurrentStoreId(): void {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    this.currentStoreId = route.snapshot.paramMap.get('storeId');
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Update store ID from current route
    this.updateCurrentStoreId();

    // Add x-tenant-id header if we have a store ID in the route
    // Backend expects 'x-tenant-id' header (lowercase)
    if (this.currentStoreId && this.currentStoreId !== '') {
      const modifiedRequest = request.clone({
        setHeaders: {
          'x-tenant-id': this.currentStoreId,
        },
      });
      return next.handle(modifiedRequest);
    }

    return next.handle(request);
  }
}

